import {Injectable} from '@angular/core';
import {HttpClient, HttpParams} from '@angular/common/http';
import {Observable, map} from 'rxjs';
import {TransferModel, DataListResponse, TransferPeriod, TransferBetweenItem} from '../models/app.models';

@Injectable({
  providedIn: 'root'
})
export class TransferService {
  private apiUrl = '/api/transfers';

  constructor(private http: HttpClient) {
  }

  /** Přestupy mezi dvěma kluby (oba směry) + zařazení do období — pohled „Přestupy mezi kluby". */
  getBetween(clubAId: number, clubBId: number): Observable<TransferBetweenItem[]> {
    const params = new HttpParams().set('clubAId', clubAId).set('clubBId', clubBId);
    return this.http.get<TransferBetweenItem[]>(`${this.apiUrl}/between`, {params});
  }

  getAll(page: number = 1, pageSize: number = 10, search?: string, sortField?: string, sortOrder?: number,
         fromClubId?: number, toClubId?: number, status?: number, type?: number, period?: string,
         playerId?: number): Observable<DataListResponse<TransferModel>> {
    let params = new HttpParams()
      .set('page', page.toString())
      .set('pageSize', pageSize.toString());

    if (search) params = params.set('search', search);
    if (sortField) params = params.set('sortField', sortField);
    if (sortOrder) params = params.set('sortOrder', sortOrder.toString());
    if (fromClubId) params = params.set('fromClubId', fromClubId.toString());
    if (toClubId) params = params.set('toClubId', toClubId.toString());
    if (status) params = params.set('status', status.toString());
    if (type) params = params.set('type', type.toString());
    if (period) params = params.set('period', period);
    if (playerId) params = params.set('playerId', playerId.toString());

    return this.http.get<DataListResponse<TransferModel>>(`${this.apiUrl}/all`, {params}).pipe(
      map(res => ({
        ...res,
        data: res.data.map((t: TransferModel) => this.trimTransferClubs(t))
      }))
    );
  }

  getPeriods(yearsBack: number = 5): Observable<TransferPeriod[]> {
    let params = new HttpParams().set('yearsBack', yearsBack.toString());
    return this.http.get<TransferPeriod[]>(`${this.apiUrl}/periods`, {params});
  }

  getById(id: number): Observable<TransferModel> {
    return this.http.get<TransferModel>(`${this.apiUrl}/${id}`).pipe(
      map(t => this.trimTransferClubs(t))
    );
  }

  getChain(id: number): Observable<TransferModel[]> {
    return this.http.get<TransferModel[]>(`${this.apiUrl}/${id}/chain`).pipe(
      map(list => list.map(t => this.trimTransferClubs(t)))
    );
  }

  private trimTransferClubs(t: TransferModel): TransferModel {
    if (t.fromClub) t.fromClub.name = t.fromClub.name?.trim();
    if (t.toClub) t.toClub.name = t.toClub.name?.trim();
    return t;
  }

  post(transfer: TransferModel): Observable<TransferModel> {
    return this.http.post<TransferModel>(this.apiUrl, transfer);
  }

  addComment(transferId: number, content: string): Observable<any> {
    return this.http.post(`${this.apiUrl}/${transferId}/comments`, { content });
  }

  updateStatus(transferId: number, status: number): Observable<void> {
    return this.http.patch<void>(`${this.apiUrl}/${transferId}/status`, status);
  }

  delete(id: number): Observable<void> {
    return this.http.delete<void>(`${this.apiUrl}/${id}`);
  }

  uploadAttachment(id: number, file: File): Observable<any> {
    const formData = new FormData();
    formData.append('file', file);
    return this.http.post(`${this.apiUrl}/${id}/attachments`, formData);
  }
}
